import React from 'react'
import Label from '../../../Form/Label'

const FooterSection = ({
    
        formData,
      setFormData,
 
      sampleGuide,
    
    
}) => {
  return (
    <main className="flex w-full justify-between gap-6">
          <div className="bg-white h-fit  flex flex-col gap-3 rounded-[10px] p-[30px] w-[42%]">
        <div className="text-customGreen  text-[17px] mb-4 font-semibold">
          Section Layout
        </div>
        <img
          src={sampleGuide.footer}
          className="w-full"
          alt="Header and Hero Preview"
        />
      </div>
      <div className="bg-white overflow-x-auto min-h-72 rounded-[10px] p-[30px] flex-1">
        <div className="flex items-center justify-between flex-1 mb-8">
          <div className="text-customGreen text-[17px] font-semibold  ">
          Customer Testimonial Section
          </div>
        </div>
            <div className="flex flex-col gap-3">
              <div className="flex  justify-between gap-2 ">
                <Label label={"Section Description"} />

                <div class="flex items-center justify-center w-[75%]">
                  <input
                    type="text"
                    value={formData.footer.description}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        footer: {
                          ...formData.footer,
                          description: e.target.value,
                        },
                      })
                    }
                    maxLength={50}
                    placeholder="Enter Description"
                    class="w-full px-4 py-2 bg-slate-100  border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none "
                  />
                </div>
              </div>
            </div>
          </div>
    </main>
  )
}

export default FooterSection
